(function () {
  'use strict';

  var app = document.getElementById('gt-sample-request-app');
  if (!app) return;

  var NETLIFY = (app.dataset.netlify || '').replace(/\/$/, '');

  var form       = document.getElementById('gt-sample-request-form');
  var successDiv = document.getElementById('gt-sr-success');
  var msgEl      = document.getElementById('gt-sr-msg');
  var submitBtn  = document.getElementById('gt-sr-submit');

  var nameInput  = document.getElementById('gt-sr-name');
  var emailInput = document.getElementById('gt-sr-email');
  var phoneInput = document.getElementById('gt-sr-phone');
  var notesInput = document.getElementById('gt-sr-notes');
  var orgInput   = document.getElementById('gt-sr-org');
  var orgDropEl  = document.getElementById('gt-sr-org-dropdown');
  var uniInput   = document.getElementById('gt-sr-university');
  var uniDropEl  = document.getElementById('gt-sr-uni-dropdown');

  var typeRadios      = document.querySelectorAll('input[name="sample_type"]');
  var garmentRadios   = document.querySelectorAll('input[name="garment_type"]');
  var panelExisting   = document.getElementById('gt-sr-panel-existing');
  var panelCustom     = document.getElementById('gt-sr-panel-custom');

  var existingInput   = document.getElementById('gt-sr-existing-product');
  var existingHandle  = document.getElementById('gt-sr-existing-handle');
  var existingDropEl  = document.getElementById('gt-sr-existing-dropdown');

  // ── Sample type toggle ─────────────────────────────────
  function getCurrentType() {
    var checked = document.querySelector('input[name="sample_type"]:checked');
    return checked ? checked.value : 'existing';
  }

  function switchPanel(type) {
    panelExisting.classList.toggle('is-active', type === 'existing');
    panelCustom.classList.toggle('is-active', type === 'custom');
  }

  var trustText = document.getElementById('gt-trust-text');
  var TRUST_EXISTING = '<strong>No strings attached.</strong> Submit the form below, we\'ll reach out to confirm your shipping address and get it on the way. One sample per chapter.';
  var TRUST_CUSTOM   = '<strong>No strings attached.</strong> Submit the form below, we\'ll reach out to work with you on your design and confirm your shipping address. One sample per chapter.';

  function updateTrustText(type) {
    if (trustText) trustText.innerHTML = type === 'custom' ? TRUST_CUSTOM : TRUST_EXISTING;
  }

  typeRadios.forEach(function (r) {
    r.addEventListener('change', function () {
      switchPanel(r.value);
      updateTrustText(r.value);
    });
  });

  // ── Existing product combobox ──────────────────────────
  var PRODUCTS = window.__gtSampleProducts || [];

  function makeCombo(inputEl, dropEl, items, onSelect) {
    if (!inputEl || !dropEl) return;

    function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

    function highlight(text, q) {
      if (!q) return document.createTextNode(text);
      var re = new RegExp('(' + escapeRe(q) + ')', 'gi');
      var frag = document.createDocumentFragment();
      text.split(re).forEach(function (p) {
        if (re.test(p)) { var m = document.createElement('mark'); m.textContent = p; frag.appendChild(m); }
        else frag.appendChild(document.createTextNode(p));
      });
      return frag;
    }

    function openList(query) {
      var q = (query || '').trim().toLowerCase();
      var matches = q
        ? items.filter(function (it) { return it.title.toLowerCase().includes(q); })
        : items.slice(0, 20);
      dropEl.innerHTML = '';
      if (!matches.length) { closeList(); return; }
      matches.forEach(function (item) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.className = 'gt-combo__thumb';
          img.alt = '';
          img.width = 36;
          img.height = 36;
          li.appendChild(img);
        }
        var span = document.createElement('span');
        span.appendChild(highlight(item.title, q));
        li.appendChild(span);
        li.addEventListener('mousedown', function (e) {
          e.preventDefault();
          inputEl.value = item.title;
          if (onSelect) onSelect(item);
          closeList();
        });
        dropEl.appendChild(li);
      });
      dropEl.hidden = false;
      inputEl.setAttribute('aria-expanded', 'true');
    }

    function closeList() {
      dropEl.hidden = true;
      inputEl.setAttribute('aria-expanded', 'false');
    }

    inputEl.addEventListener('input',  function () { openList(inputEl.value); });
    inputEl.addEventListener('focus',  function () { openList(inputEl.value); });
    inputEl.addEventListener('blur',   function () { setTimeout(closeList, 150); });
    inputEl.addEventListener('keydown', function (e) {
      if (dropEl.hidden) return;
      var lis = dropEl.querySelectorAll('li');
      var active = dropEl.querySelector('li[aria-selected="true"]');
      var idx = active ? Array.from(lis).indexOf(active) : -1;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (active) active.removeAttribute('aria-selected');
        var next = lis[Math.min(idx + 1, lis.length - 1)];
        next.setAttribute('aria-selected', 'true');
        next.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (active) active.removeAttribute('aria-selected');
        var prev = lis[Math.max(idx - 1, 0)];
        prev.setAttribute('aria-selected', 'true');
        prev.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active) {
        e.preventDefault();
        inputEl.value = active.textContent;
        closeList();
      } else if (e.key === 'Escape') {
        closeList();
      }
    });
  }

  makeCombo(existingInput, existingDropEl, PRODUCTS, function (item) {
    existingHandle.value = item.handle || '';
  });

  // ── Org / University comboboxes (same lists as custom order) ──
  var GREEK_ORGS = [
    'Alpha Chi Omega','Alpha Delta Pi','Alpha Epsilon Phi','Alpha Gamma Delta',
    'Alpha Omicron Pi','Alpha Phi','Alpha Sigma Alpha','Alpha Sigma Tau',
    'Alpha Xi Delta','Chi Omega','Delta Delta Delta','Delta Gamma','Delta Phi Epsilon',
    'Delta Zeta','Gamma Phi Beta','Kappa Alpha Theta','Kappa Delta','Kappa Kappa Gamma',
    'Phi Mu','Phi Sigma Sigma','Pi Beta Phi','Sigma Delta Tau','Sigma Gamma Rho',
    'Sigma Kappa','Sigma Lambda Gamma','Theta Phi Alpha','Zeta Phi Beta','Zeta Tau Alpha',
    'Alpha Epsilon Pi','Alpha Phi Alpha','Alpha Tau Omega','Beta Theta Pi',
    'Chi Phi','Chi Psi','Delta Chi','Delta Kappa Epsilon','Delta Sigma Phi',
    'Delta Tau Delta','Delta Upsilon','Kappa Alpha Order','Kappa Alpha Psi',
    'Kappa Sigma','Lambda Chi Alpha','Omega Psi Phi','Phi Beta Sigma',
    'Phi Delta Theta','Phi Gamma Delta','Phi Kappa Psi','Phi Kappa Sigma',
    'Phi Kappa Tau','Phi Sigma Kappa','Pi Kappa Alpha','Pi Kappa Phi',
    'Pi Lambda Phi','Sigma Alpha Epsilon','Sigma Alpha Mu','Sigma Chi',
    'Sigma Nu','Sigma Phi Epsilon','Sigma Pi','Tau Kappa Epsilon',
    'Theta Chi','Theta Delta Chi','Zeta Beta Tau','Zeta Psi'
  ];
  var UNIVERSITIES = [
    'Auburn University','Arizona State University','Boston College','Boston University',
    'Brigham Young University','Brown University','Carnegie Mellon University',
    'Clemson University','Colorado State University','Columbia University',
    'Cornell University','Dartmouth College','Duke University','Emory University',
    'Florida State University','Fordham University','George Washington University',
    'Georgetown University','Georgia Tech','Harvard University','Indiana University',
    'Iowa State University','James Madison University','Johns Hopkins University',
    'Louisiana State University','Loyola University','Marquette University',
    'Miami University','Michigan State University','New York University',
    'North Carolina State University','Northeastern University','Northwestern University',
    'Ohio State University','Oklahoma State University','Oregon State University',
    'Penn State University','Princeton University','Purdue University',
    'Rice University','Rutgers University','SMU','Syracuse University',
    'Temple University','Texas A&M University','Texas Tech University','Tulane University',
    'UC Berkeley','UC Davis','UC Irvine','UC Los Angeles','UC San Diego','UC Santa Barbara',
    'UNC Chapel Hill','University of Alabama','University of Arizona',
    'University of Arkansas','University of Colorado Boulder','University of Connecticut',
    'University of Delaware','University of Denver','University of Florida',
    'University of Georgia','University of Illinois','University of Iowa',
    'University of Kansas','University of Kentucky','University of Maryland',
    'University of Miami','University of Michigan','University of Minnesota',
    'University of Mississippi','University of Missouri','University of Nebraska',
    'University of Notre Dame','University of Oklahoma','University of Oregon',
    'University of Pennsylvania','University of Pittsburgh','University of Richmond',
    'University of South Carolina','University of Southern California',
    'University of Tennessee','University of Texas at Austin','University of Utah',
    'University of Vermont','University of Virginia','University of Washington',
    'University of Wisconsin','Vanderbilt University','Villanova University',
    'Virginia Tech','Wake Forest University','Washington University in St. Louis',
    'William & Mary','Yale University'
  ];

  makeCombo(orgInput, orgDropEl, GREEK_ORGS.map(function(s){ return { title: s }; }), null);
  makeCombo(uniInput, uniDropEl, UNIVERSITIES.map(function(s){ return { title: s }; }), null);

  // ── Validation ─────────────────────────────────────────
  function setErr(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.style.display = msg ? 'block' : 'none';
  }

  function clearErr(el) { setErr(el, ''); }

  function validate() {
    var ok = true;
    var type = getCurrentType();

    clearErr(document.getElementById('gt-sr-name-err'));
    clearErr(document.getElementById('gt-sr-contact-err'));
    clearErr(document.getElementById('gt-sr-existing-err'));
    clearErr(document.getElementById('gt-sr-garment-err'));
    clearErr(document.getElementById('gt-sr-org-err'));

    if (!nameInput.value.trim()) {
      setErr(document.getElementById('gt-sr-name-err'), 'Please enter your name.');
      nameInput.classList.add('is-invalid');
      ok = false;
    } else {
      nameInput.classList.remove('is-invalid');
    }

    if (!orgInput || !orgInput.value.trim()) {
      setErr(document.getElementById('gt-sr-org-err'), 'Please enter your chapter name.');
      if (orgInput) orgInput.classList.add('is-invalid');
      ok = false;
    } else {
      if (orgInput) orgInput.classList.remove('is-invalid');
    }

    if (!emailInput || !emailInput.value.trim()) {
      setErr(document.getElementById('gt-sr-contact-err'), 'Please provide your email address.');
      ok = false;
    }

    if (type === 'existing') {
      if (!existingInput.value.trim()) {
        setErr(document.getElementById('gt-sr-existing-err'), 'Please choose or type a product name.');
        existingInput.classList.add('is-invalid');
        ok = false;
      } else {
        existingInput.classList.remove('is-invalid');
      }
    } else {
      var garmentChecked = document.querySelector('input[name="garment_type"]:checked');
      if (!garmentChecked) {
        setErr(document.getElementById('gt-sr-garment-err'), 'Please select a garment type.');
        ok = false;
      }
    }

    return ok;
  }

  // ── Submit ─────────────────────────────────────────────
  function showMsg(text, isError) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'gt-msg' + (isError ? ' gt-msg--error' : ' gt-msg--success');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validate()) return;

    var type = getCurrentType();
    var garmentChecked = document.querySelector('input[name="garment_type"]:checked');

    var payload = {
      name:                    nameInput.value.trim(),
      email:                   emailInput ? emailInput.value.trim() : '',
      phone:                   phoneInput ? phoneInput.value.trim() : '',
      organization:            orgInput ? orgInput.value.trim() : '',
      university:              uniInput ? uniInput.value.trim() : '',
      notes:                   notesInput ? notesInput.value.trim() : '',
      sample_type:             type,
      existing_product:        type === 'existing' ? existingInput.value.trim() : '',
      existing_product_handle: type === 'existing' ? (existingHandle.value || '') : '',
      garment_type:            type === 'custom' && garmentChecked ? garmentChecked.value : '',
    };

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    fetch(NETLIFY + '/.netlify/functions/sample-request', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.success) {
          form.hidden = true;
          successDiv.hidden = false;
          app.querySelector('.gt-bulk__header').hidden = true;
          app.querySelector('.gt-sample__trust').hidden = true;
        } else {
          showMsg(data.error || 'Something went wrong. Please try again.', true);
          submitBtn.disabled = false;
          submitBtn.textContent = 'Request My Sample →';
        }
      })
      .catch(function () {
        showMsg('Network error. Please try again.', true);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Request My Sample →';
      });
  });
})();
